<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ 'settings.integration.syncRequired.title' | translate }}</h2>
    </div>
    <button mat-icon-button type="button" (click)="close()" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body">
    <div class="sync-required-dialog__info">
      <p>{{ 'settings.integration.syncRequired.message' | translate }}</p>
    </div>
  </div>

  <footer class="app-dialog__footer">
    <button mat-stroked-button type="button" (click)="close()">{{ 'close' | translate }}</button>
    <button mat-raised-button color="primary" type="button" (click)="goToSync()">
      <mat-icon>sync</mat-icon>
      {{ 'settings.integration.syncRequired.syncButton' | translate }}
    </button>
  </footer>
</div>
